import * as React from "react";
import { useCountryValue } from "../Contexts/CountryContext";
import { AdvertisementConfigurable } from "./AdvertisementConfigurable";
import { Link } from "react-router-dom";
function PhoneSexAdvertisements() {
  var state = useCountryValue()[0];
  if (state.country !== "de") {
    return null;
  }
  if (window.layoutSettings.content.phonesex.display === false || window.callData.webmasterDDI === null) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "phonesex",
    className: "prodwidth center l-container h-center c-phonesex-box"
  }, /*#__PURE__*/React.createElement("h2", null, "Klassischer Telefonsex"), /*#__PURE__*/React.createElement("div", {
    className: "c-phonesex__holder"
  }, /*#__PURE__*/React.createElement(AdvertisementConfigurable, {
    banner: window.layoutSettings.content.phonesex.banner[0]
  }), /*#__PURE__*/React.createElement(AdvertisementConfigurable, {
    banner: window.layoutSettings.content.phonesex.banner[1]
  }), /*#__PURE__*/React.createElement(AdvertisementConfigurable, {
    banner: window.layoutSettings.content.phonesex.banner[2]
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center h-center"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/telefonsex/",
    className: "btn c-button c-phonesex-box__button"
  }, "Weitere Telefonsex Kategorien")));
}
export default PhoneSexAdvertisements;